<template>
    <app-layout>
        <Head>
            <title>Anfrage einstellen</title>
        </Head>

        <template v-slot:overline>
            <translate>Anfrage einstellen</translate>
        </template>

        <template v-slot:headline>{{ this.$page.props.user.name }}</template>

        <template v-slot:stepper>
            <stepper>
                <step icon="list-basket-checkmark" class-names="active">
                    <translate>Bauteilinformationen</translate>
                </step>
                <step icon="delivery-shipment-packages-setting">
                    <translate>Lieferung</translate>
                </step>
                <step icon="credit-card-security-protection">
                    <translate>Anfrage senden</translate>
                </step>
            </stepper>
        </template>

        <div class="ask-for-quote">
            <div class="row">
                <div class="col">
                    <card>
                        <card-content>
                            <h5>
                                <translate>Erstellen Sie jetzt Ihre erste <br/> unverbindliche Fertigungsanfrage.
                                </translate>
                            </h5>
                            <form @submit.prevent="submit">
                                <div v-for="(askForQuote, index) in form.ask_for_quotes" :key="index">
                                    <div class="ask-for-quote--header" v-if="multipleAskForQuotes">
                                        <span class="overline-1">
                                            <translate>Bauteil</translate> {{ index + 1 }}
                                        </span>
                                        <form-button type="button" @click="removeAskForQuote(index)"
                                                     icon="delete-disabled-cross" dense="dense" />
                                    </div>
                                    <div class="ask-for-quote--grid">
                                        <div class="ask-for-quote--left">
                                            <form-drop-zone field="sketch_file" maxFilesize="2" fileType=".pdf"
                                                            maxFiles="1"
                                                            uploadTarget="ask-for-quote.1.upload"
                                                            deleteTarget="ask-for-quote.1.delete"
                                                            :current-file="askForQuote.sketch_file"
                                                            :error="form.errors[`ask_for_quotes.${index}.sketch_file`]"
                                                            :ask-for-quote-index="index"
                                                            @acceptFiles="form.errors[`ask_for_quotes.${index}.sketch_file`] = null;">
                                                <template v-slot:label>
                                                    <translate>Zeichnung</translate>
                                                </template>
                                                <template v-slot:textDrag>
                                                    <translate render-html="true">Legen Sie die PDF-Dateien hier
                                                        ab<br/>&nbsp;
                                                    </translate>
                                                </template>
                                                <template v-slot:textReplace>
                                                    <translate render-html="true">Legen Sie die PDF-Dateien hier ab
                                                        um
                                                        die
                                                        bestehende zu ersetzen<br/>&nbsp;
                                                    </translate>

                                                </template>
                                                <template v-slot:textdefault>
                                                    <translate render-html="true">Hochzuladende PDF-Dateien hierhin
                                                        ziehen<br/>
                                                        oder nach Dateien suchen (max. 2MB)
                                                    </translate>
                                                </template>
                                            </form-drop-zone>

                                            <form-drop-zone renderType="simplefile" field="cad_file" maxFilesize="4"
                                                            fileType=".step, .stp, .st, .dxf"
                                                            maxFiles="1" uploadTarget="ask-for-quote.1.upload"
                                                            deleteTarget="ask-for-quote.1.delete"
                                                            :current-file="askForQuote.cad_file"
                                                            :label="this.$gettext('3D-Daten (optional)')"
                                                            :info="this.$gettext('3D-Daten (*.step, *.dxf) zur Zeichnung erleichtern die Angebotserstellung und verkürzen die Fertigungszeit.')"
                                                            :error="form.errors[`ask_for_quotes.${index}.cad_file`]"
                                                            :ask-for-quote-index="index"/>

                                        </div>
                                        <div class="ask-for-quote--right">
                                            <form-input type="text" id="project_name"
                                                        :label="this.$gettext('Projekttitel')"
                                                        v-model="askForQuote.project_name"
                                                        placeholder="Your Project Titel"
                                                        :error="form.errors[`ask_for_quotes.${index}.project_name`]"
                                                        autofocus autocomplete="off"/>

                                            <form-inline>
                                                <form-input type="text" id="lotqty_1"
                                                            :label="this.$gettext('Stückzahl')"
                                                            v-model="askForQuote.lotqty_1"
                                                            placeholder="10"
                                                            :error="form.errors[`ask_for_quotes.${index}.lotqty_1`]" autocomplete="off"/>
                                                <form-input type="text" id="lotqty_2"
                                                            :label="this.$gettext('Stückzahl')"
                                                            v-model="askForQuote.lotqty_2"
                                                            placeholder="50"
                                                            :error="form.errors[`ask_for_quotes.${index}.lotqty_2`]" autocomplete="off"/>
                                                <form-input type="text" id="lotqty_3"
                                                            :label="this.$gettext('Stückzahl')"
                                                            v-model="askForQuote.lotqty_3"
                                                            placeholder="100"
                                                            :error="form.errors[`ask_for_quotes.${index}.lotqty_3`]" autocomplete="off"/>
                                                <form-input type="text" id="lotqty_4"
                                                            :label="this.$gettext('Stückzahl')"
                                                            v-model="askForQuote.lotqty_4"
                                                            placeholder="200"
                                                            :error="form.errors[`ask_for_quotes.${index}.lotqty_4`]" autocomplete="off"/>
                                            </form-inline>

                                            <form-datepicker id="delivery_date"
                                                             :label="this.$gettext('Wunschliefertermin (optional)')"
                                                             v-model:date="askForQuote.delivery_date"
                                                             :error="form.errors[`ask_for_quotes.${index}.delivery_date`]" :min-date="minAskForQuoteDate" :max-date="maxAskForQuoteDate"/>
                                            <form-input type="text" id="internal_article_number"
                                                        :label="this.$gettext('Ihre Artikelnummer optional)')"
                                                        v-model="askForQuote.internal_article_number"
                                                        :error="form.errors[`ask_for_quotes.${index}.internal_article_number`]" autocomplete="off"/>
                                            <form-input type="text" id="internal_ask_number"
                                                        :label="this.$gettext('Ihre Anfragenummer (optional)')"
                                                        v-model="askForQuote.internal_ask_number"
                                                        :error="form.errors[`ask_for_quotes.${index}.internal_ask_number`]" autocomplete="off"/>
                                            <div class="form-actions"
                                                 v-if="index == Object.keys(form.ask_for_quotes).length - 1">
                                                <form-button type="submit" color="secondary"
                                                             icon="button-arrow-right-circle" :disabled="form.processing" :class="{'btn--processing': form.processing}">
                                                    <translate>weiter zum nächsten Schritt</translate>
                                                </form-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </card-content>
                    </card>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <form-button @click="addAskForQuote" class="btn--block btn--dashed" icon="documents-file-add-plus">
                        <translate>weiteres Bauteil hinzufügen</translate>
                    </form-button>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from '@partfactory/Layouts/AppLayout';
import {useForm} from '@inertiajs/vue3';
import Card from '@partfactory/Shared/Card/Card';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormInput from '@partfactory/Shared/Form/FormInput';
import FormButton from '@partfactory/Shared/Form/FormButton';
import Stepper from '@partfactory/Shared/Stepper/Stepper';
import Step from '@partfactory/Shared/Stepper/Step';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';
import FormInline from '@partfactory/Shared/Form/FormInline';
import FormDropZone from '@partfactory/Shared/Form/FormDropZone';

export default {
    name: 'AskForQuote.1',
    components: {
        FormDropZone,
        FormInline,
        FormDatepicker,
        Step,
        Stepper,
        FormButton,
        FormInput,
        CardContent,
        Card,
        AppLayout,
    },
    props: {
        askForQuotes: Object,
        sketchFiles: Object,
        cadFiles: Object,
        errors: Object,
    },
    data() {
        let askForQuotesProxy = this.askForQuotes;
        let sketchFilesProxy = this.sketchFiles ? this.sketchFiles : {};
        let cadFilesProxy = this.cadFiles ? this.cadFiles : {};

        const form = useForm({
            ask_for_quotes: [],
        });

        if (askForQuotesProxy === null && Object.keys(sketchFilesProxy)?.length === 0 && Object.keys(cadFilesProxy)?.length === 0) {
            form.ask_for_quotes.push({
                project_name: null,
                lotqty_1: null,
                lotqty_2: null,
                lotqty_3: null,
                lotqty_4: null,
                delivery_date: null,
                internal_article_number: null,
                internal_ask_number: null,
                sketch_file: null,
                cad_file: null,
            });
        }

        return {form, askForQuotesProxy, sketchFilesProxy, cadFilesProxy};
    },
    computed: {
        multipleAskForQuotes() {
            return this.form.ask_for_quotes.length > 1;
        },
        minAskForQuoteDate() {
            return this.$moment(new Date()).businessAdd(Number(this.$page.props.factors.min_delivery_time_ask_for_quote))._d;
        },
        maxAskForQuoteDate() {
            return this.$moment(new Date()).add(Number(this.$page.props.factors.max_delivery_time_ask_for_quote), 'weeks')._d;
        }
    },
    mounted() {
        if (this.askForQuotesProxy !== null && (this.askForQuotesProxy.length > Object.keys(this.sketchFilesProxy)?.length || this.sketchFilesProxy === null) && (this.askForQuotesProxy.length > Object.keys(this.cadFilesProxy)?.length || this.cadFilesProxy === null)) {
            for (const [key] of Object.entries(this.askForQuotesProxy)) {
                this.form.ask_for_quotes.push({
                    project_name: this.askForQuotesProxy?.[key]?.project_name,
                    lotqty_1: this.askForQuotesProxy?.[key]?.lotqty_1,
                    lotqty_2: this.askForQuotesProxy?.[key]?.lotqty_2,
                    lotqty_3: this.askForQuotesProxy?.[key]?.lotqty_3,
                    lotqty_4: this.askForQuotesProxy?.[key]?.lotqty_4,
                    delivery_date: this.askForQuotesProxy?.[key]?.delivery_date,
                    internal_article_number: this.askForQuotesProxy?.[key]?.internal_article_number,
                    internal_ask_number: this.askForQuotesProxy?.[key]?.internal_ask_number,
                    sketch_file: this.sketchFilesProxy?.[key] ? this.sketchFilesProxy?.[key] : null,
                    cad_file: this.cadFilesProxy?.[key] ? this.cadFilesProxy?.[key] : null,
                });
            }
        } else if (this.sketchFilesProxy !== null && (Object.keys(this.sketchFilesProxy)?.length > Object.keys(this.cadFilesProxy)?.length || this.cadFilesProxy === null)) {
            for (const [key] of Object.entries(this.sketchFilesProxy)) {
                this.form.ask_for_quotes.push({
                    project_name: this.askForQuotesProxy?.[key]?.project_name,
                    lotqty_1: this.askForQuotesProxy?.[key]?.lotqty_1,
                    lotqty_2: this.askForQuotesProxy?.[key]?.lotqty_2,
                    lotqty_3: this.askForQuotesProxy?.[key]?.lotqty_3,
                    lotqty_4: this.askForQuotesProxy?.[key]?.lotqty_4,
                    delivery_date: this.askForQuotesProxy?.[key]?.delivery_date,
                    internal_article_number: this.askForQuotesProxy?.[key]?.internal_article_number,
                    internal_ask_number: this.askForQuotesProxy?.[key]?.internal_ask_number,
                    sketch_file: this.sketchFilesProxy?.[key] ? this.sketchFilesProxy?.[key] : null,
                    cad_file: this.cadFilesProxy?.[key] ? this.cadFilesProxy?.[key] : null,
                });
            }
        } else if (this.cadFilesProxy !== null) {
            for (const [key] of Object.entries(this.cadFilesProxy)) {
                this.form.ask_for_quotes.push({
                    project_name: this.askForQuotesProxy?.[key]?.project_name,
                    lotqty_1: this.askForQuotesProxy?.[key]?.lotqty_1,
                    lotqty_2: this.askForQuotesProxy?.[key]?.lotqty_2,
                    lotqty_3: this.askForQuotesProxy?.[key]?.lotqty_3,
                    lotqty_4: this.askForQuotesProxy?.[key]?.lotqty_4,
                    delivery_date: this.askForQuotesProxy?.[key]?.delivery_date,
                    internal_article_number: this.askForQuotesProxy?.[key]?.internal_article_number,
                    internal_ask_number: this.askForQuotesProxy?.[key]?.internal_ask_number,
                    sketch_file: this.sketchFilesProxy?.[key] ? this.sketchFilesProxy?.[key] : null,
                    cad_file: this.cadFilesProxy?.[key] ? this.cadFilesProxy?.[key] : null,
                });
            }
        }


    },
    methods: {
        addAskForQuote() {
            this.form.ask_for_quotes.push({
                project_name: null,
                lotqty_1: null,
                lotqty_2: null,
                lotqty_3: null,
                lotqty_4: null,
                delivery_date: null,
                internal_article_number: null,
                internal_ask_number: null,
                sketch_file: null,
                cad_file: null,
            });
        },
        removeAskForQuote(index) {
            this.form.ask_for_quotes.splice(index, 1);
            if (Object.keys(this.sketchFilesProxy)?.length > 0) {
                this.sketchFilesProxy.splice(index, 1);
            }
            if (Object.keys(this.cadFilesProxy)?.length > 0) {
                this.cadFilesProxy.splice(index, 1);
            }
            this.$inertia.post(this.$$route('ask-for-quote.1.remove'), {
                _token: this.$page.props.csrf_token,
                'askForQuoteIndex': index,
            }, {
                onSuccess: () => {
                    location.reload();
                },
            });
        },
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('ask-for-quote.1.post'), {
                    onSuccess: () => {
                        // Anfrage-Formular abgeschickt (Schritt 1)
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'form_send',
                            'formName': 'Anfrage',
                            'formStep': '1 - Anfrage einstellen, Bauteilinformationen',
                            'formLang': this.$language.current,
                        });
                    }
                });
        }
    }
};
</script>
